import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { revealOnScroll } from '../../utils/animations';
import styles from './About.module.scss';

const About: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      revealOnScroll(containerRef.current);
    });
    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.aboutSection} id="about" ref={containerRef}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.content}>
            <span className={styles.sectionLabel}>WHO WE ARE</span>
            <h2 className={styles.sectionTitle}>
              ABOUT RASH DIGITAL <span className={styles.highlight}>MARKETING</span>
            </h2>
            <p className={styles.description}>
              Rash Digital Marketing is a results-driven digital marketing agency based in Indore, India, dedicated to helping businesses establish a strong online presence and achieve sustainable growth. Since 2019, we have been delivering innovative digital marketing solutions that increase brand visibility, generate quality leads, and drive business revenue.
            </p>
            <p className={styles.description}>
              With 6+ years of industry experience, we have successfully worked with businesses across healthcare, real estate, education, beauty, hospitality, retail, and many other industries. Our mission is to provide customized marketing strategies that help our clients reach the right audience, build trust, and achieve measurable results.
            </p>
            <p className={styles.description}>
              Our team specializes in Social Media Marketing, Google Business Profile (GBP) Optimization, Search Engine Optimization (SEO), Google Ads, Meta Ads, Website Design & Development, Branding, Content Creation, and Performance Marketing. Every campaign is designed with a data-driven approach to maximize return on investment and deliver long-term success.
            </p>
            <p className={styles.description}>
              Whether you're a startup, local business, clinic, restaurant, real estate company, or an established brand, Rash Digital Marketing is committed to helping you grow faster with powerful digital marketing solutions.
            </p>
          </div>

          <div className={styles.sidebar}>
            {/* Why Choose Card */}
            <div className={styles.whyChooseCard}>
              <h3 className={styles.sidebarTitle}>Why Choose Rash Digital?</h3>
              <ul className={styles.featuresList}>
                <li>
                  <span className={styles.icon}>✓</span>
                  <div>
                    <strong>Established in 2019</strong>
                    <p>Over 8 years of digital expertise helping brands scale.</p>
                  </div>
                </li>
                <li>
                  <span className={styles.icon}>✓</span>
                  <div>
                    <strong>Trusted by 100+ Businesses</strong>
                    <p>Proven track record across multiple competitive industries.</p>
                  </div>
                </li>
                <li>
                  <span className={styles.icon}>✓</span>
                  <div>
                    <strong>All-in-One Solutions</strong>
                    <p>Complete digital marketing ecosystem under one roof.</p>
                  </div>
                </li>
                <li>
                  <span className={styles.icon}>✓</span>
                  <div>
                    <strong>Transparent & Direct</strong>
                    <p>Clear, data-backed reporting and result-oriented strategies.</p>
                  </div>
                </li>
                <li>
                  <span className={styles.icon}>✓</span>
                  <div>
                    <strong>Dedicated Support</strong>
                    <p>Growth-focused support prioritizing customer satisfaction.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
